interface SuccessToastProps {
  title: string;
  message: string;
}

export const SuccessToast = ({ title, message }: SuccessToastProps) => {
  return (
    <div className='flex items-center gap-3'>
      <div className='w-16 h-16 flex justify-center items-center bg-[#F9F9AE] rounded-md'>
        <svg className='w-10 h-10 text-[#838300]' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
          />
        </svg>
      </div>
      <div>
        <h2 className='font-semibold text-primary-600'>{title}</h2>
        <p className='text-primary-400'>{message}</p>
      </div>
    </div>
  );
};
